<template>
    <div class="search-head-com">
        <el-popover placement="bottom" trigger="manual" popper-class="search-popper" :visible-arrow="false"
            v-model="isShowOptions">
            <el-input slot="reference" v-model.trim="searchValue" v-bind="$attrs" v-on="$listeners"
                :class="['home-input-box', inputClass]" size="mini" :placeholder="placeholder" @clear="clearHandle"
                clearable @focus="isShowOptions = true" @blur="isShowOptions = false" @input="inputHandle"
                @keydown.enter.native="handleIconClick">
            </el-input>
            <div class="search-complete-list">
                <p class="search-complete-list-item" v-for="(option, index) in filteredOptions" :key="index"
                    @click="selectOption(option)">
                    {{ option.name }}
                </p>
            </div>
        </el-popover>
    </div>
</template>

<script>
import { ref, watch } from '@vue/composition-api';
import _ from 'lodash';
export default {
    components: {},
    props: {
        config: {
            type: Object,
            return: () => { }
        },
        detailDataLocal: {
            type: Object,
            return: () => { }
        },
        inputClass: {
            type: String,
            default: () => {
                return '';
            }
        },
        inputValue: {
            type: String,
            default: () => {
                return '';
            }
        },
        placeholder: {
            type: String,
            default: () => {
                return '请输入';
            }
        }
    },
    /* eslint-disable max-lines-per-function */
    setup(props, setupContext) {
        const inputText = ref('');
        const searchValue = ref('');
        const isShowOptions = ref(false);
        const filteredOptions = ref([]);
        watch(() => props.inputValue, (val) => {
            searchValue.value = val;
        }, { deep: true, immediate: true });
        // eslint-disable-next-line complexity
        const inputHandle = _.debounce(async (val) => {
            setupContext.emit('inputHandle', val);
            if (!val.length) {
                isShowOptions.value = false;
                return;
            }
            isShowOptions.value = true;

            if (!val) {
                this.filteredOptions = [];
                return;
            }
            try {
                // 联想接口请求
                let params = {
                    enterpriseName: searchValue.value,
                    pageNum: 1,
                    pageSize: 20
                };

                // 添加请求前钩子，用于非标准化基础数据接口对请求参数做数据转换
                const isRequest = _.get(props.config, 'isRequest');
                if (isRequest && _.isFunction(isRequest) && isRequest(searchValue.value)) {
                    return false;
                }
                // 添加请求前钩子，用于非标准化基础数据接口对请求参数做数据转换
                const beforeReq = _.get(props.config, 'beforeRequest');
                if (beforeReq && _.isFunction(beforeReq)) {
                    params = beforeReq(params);
                }
                const apiUrl = props.config.apiUrl;
                let res = await apiUrl(params);
                const afterRes = _.get(props.config, 'afterResponse');
                if (afterRes && _.isFunction(afterRes)) {
                    res = afterRes(res);
                }
                if (res && res.code === '0') {
                    filteredOptions.value = res.data;
                } else {
                    filteredOptions.value = [];
                }
                // const options = await response.json();
                // this.filteredOptions = options;
            } catch (error) {
                filteredOptions.value = [];
                console.error('Failed to fetch options:', error);
            }
            // eslint-disable-next-line no-magic-numbers
        }, 400);

        const selectOption = (option) => {
            searchValue.value = option.name;
            isShowOptions.value = false;
            filteredOptions.value = [];
            setupContext.emit('clickItem', option);
        };

        const clearHandle = () => {

        };

        const handleIconClick = () => {
            isShowOptions.value = false;
            setupContext.emit('handleIconClick', searchValue.value);
        };
        return {
            searchValue,
            inputText,
            filteredOptions,
            selectOption,
            isShowOptions,
            clearHandle,
            inputHandle,
            handleIconClick
        };
    }
};
</script>
<style lang="less" scoped>
.search-head-com {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .home-input-box {
        // background: #FFFFFF;
        height: 36px;
    }

}
</style>
<style lang="less">
.search-popper {
    // width: 474px !important;
    // top: 115px !important;
    // left: 230px;
    margin-top: 2px !important;

    .search-complete-list {
        width: 100%;
        padding: 0 12px;
        box-sizing: border-box;
        height: 220px;
        overflow-y: auto;

        .search-complete-list-item {
            margin: 0;
            padding: 7px 0;
            cursor: pointer;
            width: 100%;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .search-complete-list-item:hover {
            background: #F3F4F6;
        }
    }
}

// .search-bottom-radius.el-input .el-input__inner {
//     border-bottom-left-radius: 0px !important;
//     border-bottom-right-radius: 0px !important;
// }</style>
